<template>
  <section class="section-service col-12">
    <!-- <q-tab-panels v-model="panel" class="panel-services">
      <q-tab-panel class="panel-item" name="tab-1">
      </q-tab-panel>
    </q-tab-panels> -->
    <div class="title-page">Dados da solicitação</div>

        <q-form ref="formtab1">
          <div class="group-input col-12 row q-mt-sm">
            <label for="type-os">Tipo de OS</label>
            <q-select
              id="type-os"
              class="col-12 q-mt-sm form-tabulacao"
              outlined
              dense
              ref="typeOSRef"
              v-model="requestData.typeOS"
              color="red-9"
              @filter="getTypeOsByClassification"
              use-input
              hide-selected
              fill-input
              input-debounce="0"
              :options="optionsTypeOS"
              option-value="value"
              option-label="text"
              bg-color="white"
              :rules="[(val) => !!val || 'Campo Obrigatório']"
              lazy-rules
            />
          </div>

          <div class="group-input col-12 column q-mt-lg">
            <label for="write-off-code">Tipo de agendamento</label>
            <div class="flex row justify-around">
              <q-radio
                v-model="requestData.movimentscheduling"
                keep-color
                val="Realizar agendamento"
                size="lg"
                label="Realizar agendamento"
                color="red-6"
                :disable="numericalTypeOs === MDU_MODERNIZACAO"

              />
              <q-radio
                
                v-model="requestData.movimentscheduling"
                keep-color
                val="Abertura imediata"
                size="lg"
                label="Abertura imediata"
                color="red-6"
                :disable="numericalTypeOs == CONTROLE_QUALIDADE"
              />
            </div>
          </div>
          <div class="group-input col-12 row q-mt-sm" v-if="!isImmediateScheduling">
            <label for="type-os">Opção 1</label>
            <div class="group-input col-12 row q-mt-sm flex justify-around">
              <q-select
                id="type-os"
                class="col-5 q-mt-sm form-tabulacao"
                outlined
                dense
                ref="typeOSRef"
                v-model="requestData.option1"
                color="red-9"
                use-input
                hide-selected
                fill-input
                input-debounce="0"
                :options="datesHoursAvailableForSelection.date"
                option-value="value"
                option-label="text"
                bg-color="white"
                lazy-rules
                :rules="[(val) => !!val || 'Campo Obrigatório']"
                :disable="isImmediateScheduling"
              />
              <q-select
                id="type-os"
                class="col-5 q-mt-sm form-tabulacao"
                outlined
                dense
                ref="typeOSRef"
                v-model="requestData.hourOption1"
                color="red-9"
                use-input
                hide-selected
                fill-input
                input-debounce="0"
                :options="hoursList"
                option-value="value"
                option-label="text"
                bg-color="white"
                lazy-rules
                :rules="[(val) => !!val || 'Campo Obrigatório']"
                :disable="isImmediateScheduling"
              />
            </div>
          </div>

          <div class="group-input col-12 row q-mt-sm" v-if="!isImmediateScheduling">
            <label for="type-os">Opção 2</label>
            <div class="group-input col-12 row q-mt-sm flex justify-around">
              <q-select
                id="type-os"
                class="col-5 q-mt-sm form-tabulacao"
                outlined
                dense
                ref="typeOSRef"
                v-model="requestData.option2"
                color="red-9"
                use-input
                hide-selected
                fill-input
                input-debounce="0"
                :options="datesHoursAvailableForSelection.date"
                option-value="value"
                option-label="text"
                bg-color="white"
                lazy-rules
                :rules="[(val) => !!val || 'Campo Obrigatório']"
                :disable="isImmediateScheduling"
              />

              <q-select
                id="type-os"
                class="col-5 q-mt-sm form-tabulacao"
                outlined
                dense
                ref="typeOSRef"
                v-model="requestData.hourOption2"
                color="red-9"
                use-input
                hide-selected
                fill-input
                input-debounce="0"
                :options="hoursList"
                option-value="value"
                option-label="text"
                bg-color="white"
                lazy-rules
                :rules="[(val) => !!val || 'Campo Obrigatório']"
                :disable="isImmediateScheduling"
              />
            </div>
          </div>

          <div class="group-input col-12 row q-mt-sm" v-if="numericalTypeOs === MDU_MODERNIZACAO && !isImmediateScheduling">
            <label for="type-os">Opção 3</label>
            <div class="group-input col-12 row q-mt-sm flex justify-around">
              <q-select
                id="type-os"
                class="col-5 q-mt-sm form-tabulacao"
                outlined
                dense
                ref="typeOSRef"
                v-model="requestData.option3"
                color="red-9"
                use-input
                hide-selected
                fill-input
                input-debounce="0"
                :options="datesHoursAvailableForSelection.date"
                option-value="value"
                option-label="text"
                bg-color="white"
                lazy-rules
                :rules="[(val) => !!val || 'Campo Obrigatório']"
                :disable="isImmediateScheduling"
              />

              <q-select
                id="type-os"
                class="col-5 q-mt-sm form-tabulacao"
                outlined
                dense
                ref="typeOSRef"
                v-model="requestData.hourOption3"
                color="red-9"
                use-input
                hide-selected
                fill-input
                input-debounce="0"
                :options="hoursList"
                option-value="value"
                option-label="text"
                bg-color="white"
                lazy-rules
                :rules="[(val) => !!val || 'Campo Obrigatório']"
                :disable="isImmediateScheduling"
              />
            </div>
          </div>

          <SelectCheckbox title="Atendimento fora TOA" @selectedOption="(value) => setToa(value)" :selection="requestData.serviceOutsideToa"
          :options="toaOptions" v-if="false" />
            
          <div class="group-input col-12 row q-mt-md">
            <label for="observation">Observação</label>
            <div class="col-12 row flex justify-around">
              <q-input
                v-model="requestData.observation"
                class="col-12 q-mt-sm"
                bg-color="white" 
                color="red-9"
                maxlength="120"
                outlined
                autogrow
                :rules="[(val) => !!val || 'Campo Obrigatório']"
                lazy-rules
              />
            </div>
          </div> 
          </q-form>

    <div>
      <q-footer elevated>
        <q-toolbar>
          <div class="flex col-12 row items-center justify-between">
            <div
              class="col-12 justify-between flex items-center"
            >
              <q-btn
                outline
                unelevated
                rounded
                color="red-9"
                @click="$emit('removeEdit')"
                label="voltar"
              />
              <q-btn
                unelevated
                rounded
                color="red-9"
                @click="validateForm"
                label="Concluir"
              />
            </div>
            
          </div>
        </q-toolbar>
      </q-footer>
    </div>
  </section>
</template>

<script>
import DateTimePicker from "@/components/DateTimePicker";
import AttendanceClock from "@/components/generatedOsForm/AttendanceClock.vue";
import SelectCheckbox from "@/components/SelectCheckbox";
import { MDU_MODERNIZACAO,  } from "@/utils/constants/typeAttendance";
import {
  CONTROLE_QUALIDADE,
} from "@/utils/constants/typeOs/generateOs";
import { generateDays, generateNextTenDays } from "@/utils/DateSchedules";
import moment from "moment";
import { useQuasar } from "quasar";
import { computed, onMounted, reactive, ref } from "vue";

export default {
  name: "MeshForm",
  components: {
    SelectCheckbox,
    DateTimePicker,
    AttendanceClock,
  },
  props: {
    listWriteOffCode: Array,
    listTypeOS: Array,
    optionsWriteOffCode: Array,
    optionsTypeOS: Array,
    optionsTypeOSByClassification: Array,
    optionsActionOs: Array,
    optionsStateEquipaments: Array,
    itemOsContract: Object,
    typeOs: String,
  },
  emits: [
    "saveSchemaRequest",
    "clearSchemaRequest",
    "removeEdit",
    "getTypeOsClassification",
    "disabledtabButton",
  ],

  setup(props, { emit }) {
    moment.locale("pt-br");

    const $q = useQuasar();
    const ACTION_INSTALLED_ID = ref(2);
    const ACTION_DEVOLUTION_ID = ref(3);

    const datesHoursAvailableForSelection = reactive({
      date: [],
      hour: [
        {
          id: 1,
          text: "08h - 12h",
          value: "08 - 12",
        },
        {
          id: 2,
          text: "12h - 15h",
          value: "12 - 15",
        },
        {
          id: 3,
          text: "15h - 18h",
          value: "15 - 18",
        },
      ],
    });

    const toaOptions = [
      {
        label: "Sim",
        value: 1,
      },
      {
        label: "Não",
        value: 0,
      },
    ];
    let panel = ref("tab-1");
    let tabindex = ref(1);
    let progressBar = ref(0.5);

    const numericalTypeOs = Number(props.typeOs);

    const hoursList = numericalTypeOs === MDU_MODERNIZACAO ? datesHoursAvailableForSelection.hour.slice(0, 1) : datesHoursAvailableForSelection.hour;

    let requestData = reactive(props.itemOsContract);

    let schemaRequest = reactive({
      object_id: "",
      osNumber: "",
      typeOS: "",
      statusOS: 1,
      writeOffCode: "",
      observation: "",
      check: false,
      replicate: false,
      source: "",
      action: 1,
      state: 1,
      equipamentNumberInstall: "",
      equipamentNumberDesinstall: "",
      cardNumberInstaled: "",
      cardNumberUninstalled: "",
    });
    const formtab1 = ref(null);

    const listTypeOS = ref([]);
    const listWriteOffCode = ref([]);

    const optionsItens = reactive({
      optionsTypeOS: listTypeOS,
      optionsWriteOffCode: listWriteOffCode,
    });

    function setTypeOsByServiceOption() {
      if (props.optionsTypeOS.length == 1) {
        requestData.typeOS = props.optionsTypeOS[0];
      }
    }

    function getTypeOsByClassification(val, update) {
      let selectedOption = props.optionsActionOs.find(
        (option) => option.id_acao == requestData.action
      );

      update(() => {
        optionsItens.optionsTypeOS = props.listTypeOS.filter((optionTypeOS) => {
          return (
            optionTypeOS.id_classificacao == selectedOption.id_classificacao
          );
        });
      });
    }

    async function validateForm() {
      let validation = false;
      // if (requestData.serviceOutsideToa != 1 && requestData.serviceOutsideToa != 0 ) { 
      //   $q.notify({
      //     message: "O campo Toa é obrigatório",
      //     color: "red-9",
      //     position: "top",
      //     timeout: 3000,
      //   });
      //   return;
      // }
      validation = await formtab1.value.validate();
      if (validation) {
        await emitData();
      }
      return validation;
    }

    async function emitData() {
      emit("saveSchemaRequest", requestData);
    }

     function updateDate() {
      requestData.option1 = ""
      requestData.option2 = ""
      requestData.hourOption1 = ""
      requestData.hourOption2 = ""
      requestData.option3 = ""
      requestData.hourOption3 = ""
    }

    function setToa(value) {
      requestData.serviceOutsideToa = value
    }

    function _changeTab() {
      const VALUE_INCREMENT_ID_TAB = 1;
      const STRING_ID_TAB = "tab-";

      tabindex.value += VALUE_INCREMENT_ID_TAB;
      panel.value = STRING_ID_TAB + tabindex.value;

      return true;
    }

    async function addValueBarProgressAndAlterTab() {
      const VALUE_MAX_BAR_PROGRESS = 1;
      const VALUE_ADD_PROGRESS = 0.5;

      if (
        progressBar.value != VALUE_MAX_BAR_PROGRESS &&
        (await validateForm())
      ) {
        let validateIfChangeTab = _changeTab();

        if (validateIfChangeTab) {
          progressBar.value += VALUE_ADD_PROGRESS;
        }
      }
    }

    function addDateSchedule() {
      numericalTypeOs === MDU_MODERNIZACAO
        ? (datesHoursAvailableForSelection.date = generateDays(3))
        : (datesHoursAvailableForSelection.date = generateNextTenDays());
    }

    const isImmediateScheduling = computed(() => {
      return requestData.movimentscheduling == "Abertura imediata";
    });

    onMounted(() => {
      if (numericalTypeOs == CONTROLE_QUALIDADE) {
           requestData.movimentscheduling = "Realizar agendamento";
      } else {
        requestData.movimentscheduling = "Abertura imediata";
      }  
      
        // 'Realizar agendamento';
      setTypeOsByServiceOption();
      addDateSchedule();
    });

    return {
      ACTION_INSTALLED_ID,
      ACTION_DEVOLUTION_ID,
      datesHoursAvailableForSelection,
      panel,
      tabindex,
      progressBar,
      schemaRequest,
      requestData,
      optionsItens,
      updateDate,
      formtab1,
      toaOptions,
      validateForm,
      getTypeOsByClassification,
      setToa,
      isImmediateScheduling,
      hoursList,
      MDU_MODERNIZACAO,
      CONTROLE_QUALIDADE,
      numericalTypeOs,
    };
  },
};
</script>

<style scoped lang="scss">
label {
  font-family: Roboto;
  font-style: normal;
}

.q-page-container {
  padding-bottom: 0px !important;
}

.label-checkbox-confirm {
  font-weight: 500 !important;
  font-size: 12px !important;
  line-height: 14px !important;
  letter-spacing: 0.01em !important;
  color: #999999 !important;
}

footer {
  background: #ffffff !important;
  height: 12vh;

  .q-toolbar {
    height: 12vh;
  }

  .div-progress {
    height: 8vh;
  }

  .div-btn-next {
    height: 8vh;
  }
}

.section-service {
  width: 100%;

  .panel-services {
    background: transparent !important;
    overflow: hidden !important;

    .title-page {
      font-weight: bold;
      font-size: 18px;
      line-height: 19px;
      text-transform: uppercase;
      color: #e2262d;
    }

    .group-input {
      label {
        font-weight: bold;
        font-size: 14px;
        color: rgba(0, 0, 0, 0.4);
      }
    }

    .label-requests-number {
      font-weight: 600;
      font-size: 15px;
      line-height: 20px;
      color: rgba(0, 0, 0, 0.5);
    }

    .label-requests-description {
      font-weight: 500;
      font-size: 12px;
      line-height: 20px;
      color: rgba(0, 0, 0, 0.8);
    }
  }
}
</style>